const TourContent = ({heading, body}) => {
    return (
        <div>
            <p className="tour-heading">{heading}</p>
            <p className="tour-body">{body}</p>
        </div>
    )
}

export default TourContent